import * as React from 'react'

interface FormLetterIconProps {
  color?: string
  gradient?: boolean
  size?: number
  alt?: string
}

const FormLetterIcon: React.FC<FormLetterIconProps> = ({
  color = '#000',
  gradient,
  size = 24,
  alt = 'Form letter icon',
  ...props
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 26 25'
      aria-label={alt}
      {...props}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M3.5 1.664c-1.004-.053-1.875.818-1.875 1.883v1.32h3.63V3.434c0-.506-.197-.934-.514-1.22l-.02-.02a1.88 1.88 0 0 0-1.221-.53M.375 3.547C.375 1.842 1.773.319 3.568.415h.003a3.13 3.13 0 0 1 2.02.882c.585.536.914 1.302.914 2.137v2.058c0 .346-.28.625-.625.625H1a.625.625 0 0 1-.625-.625z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M2.908 1c0-.345.28-.625.625-.625h14.83c1.058 0 1.93.742 2.092 1.761a1 1 0 0 1 .008.099v7.184a.625.625 0 0 1-1.25 0V2.291c-.081-.382-.412-.666-.85-.666H3.532A.625.625 0 0 1 2.908 1M19.877 12.784c.345 0 .625.28.625.625v6.937a.625.625 0 0 1-1.25 0v-6.937c0-.345.28-.625.625-.625'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M5.88 2.807c.346 0 .626.28.626.625v17.923c0 .958.81 1.77 1.796 1.77.513 0 .962-.195 1.3-.53.343-.34.534-.78.534-1.24v-1.01c0-.345.28-.625.625-.625h13.694c.345 0 .625.28.625.625v1.01c0 .836-.329 1.602-.914 2.138a3.07 3.07 0 0 1-2.17.882H8.302c-1.663 0-3.046-1.359-3.046-3.02V3.432c0-.346.28-.625.625-.625m4.913 20.318h11.203a1.82 1.82 0 0 0 1.32-.55c.317-.286.514-.713.514-1.22v-.385H11.386v.385a2.96 2.96 0 0 1-.593 1.77'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M22.406 5.63a.63.63 0 0 1 .57-.221c1.025.144 1.779.749 2.16 1.74.082.21.044.448-.1.622l-7.338 8.943a.6.6 0 0 1-.19.155l-2.458 1.31a.625.625 0 0 1-.893-.731l.794-2.657a.6.6 0 0 1 .116-.217zm.72 1.093-7.013 8.547-.33 1.102 1.028-.547 7.007-8.54a1.28 1.28 0 0 0-.691-.562'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M21.421 7.848a.625.625 0 0 1 .879-.096l2.837 2.283a.625.625 0 0 1 .036.943l-1.386 1.3-.667 1.46a.625.625 0 0 1-1.137-.52l.719-1.572a.6.6 0 0 1 .14-.196l.951-.892-2.276-1.832a.625.625 0 0 1-.096-.878M8.307 7.204c0-.345.28-.625.625-.625h7.318a.625.625 0 0 1 0 1.25H8.932a.625.625 0 0 1-.625-.625M8.307 10.307c0-.346.28-.625.625-.625h6.272a.625.625 0 1 1 0 1.25H8.932a.625.625 0 0 1-.625-.625M8.307 13.41c0-.346.28-.626.625-.626h3.136a.625.625 0 1 1 0 1.25H8.932a.625.625 0 0 1-.625-.625'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default FormLetterIcon
